<template>
  <div>
    <v-row align="center" class="pa-4">
      <v-card-title>Журнал открытия двери</v-card-title>
      <div class="ml-2">
        <BaseTextField
          v-model="filterCode"
          :is-button="false"
          :is-switch="true"
          icon="mdi-magnify"
          label="Введите код ключа"
        />
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer mt-1 mb-2"
            v-bind="attrs"
            v-on="on"
            @click="updateInfo"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>
    <v-data-table
      class="table"
      :headers="getHeaders"
      :items="filtered"
      :sort-desc="true"
      :footer-props="{
          'items-per-page-options': [10, 30, 50],
          showFirstLastPage: true
      }"
    >
      <template v-slot:item.relay="{ item }">
        <span v-if="item.relay === 1">{{ 'Реле 1'}}</span>
        <span v-if="item.relay === 2">{{ 'Реле 2'}}</span>
      </template>
      <template v-slot:item.Date="{ item }">
        {{ metDateTime(item.Date, item.Time) }}
      </template>
      <template v-slot:item.Status="{item}">
      <span :style="(+item.Status === 0) ? 'color: red;' : 'color:green;'">
        {{ getJournalStatus(item.Status) }}
      </span>
      </template>
      <template v-slot:item.Type="{item}">
        {{ getJournalType(item.Type) }}
      </template>
      <template v-slot:item.Code="{ item }">
        {{ keyCode(item.Code) }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { headersJournal, JOURNAL_TYPES, JOURNAL_STATUS, JOURNAL_TYPES_RUBETEK3434, headersJournal3434 } from '../../../consts';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import BaseTextField from '../../../../../BaseTextField';

export default {
  name: 'JournalDoor',
  components: { BaseTextField },
  props: ['id'],
  mixins: [ruDateFormatMixin],
  data () {
    return {
      headersJournal,
      headersJournal3434,
      filterCode: '',
      intercom: {},
    };
  },
  created () {
    return this.getJournalDoor();
  },
  computed: {
    ...mapGetters({
      journal: 'DoorJournal/journal',
      doorphone: 'Doorphone/doorphone',
      roleName: 'roleName',
    }),
    filtered () {
      if (this.filterCode) {
        const search = this.filterCode.toLowerCase();
        return this.journal.filter(item =>
          this.keyCode(item.Code).toLowerCase().includes(search),
        );
      } else {
        return this.journal;
      }
    },
    getHeaders () {
      if (this.doorphone.device.model === 'RV-3434') {
        return this.headersJournal3434;
      } else {
        return this.headersJournal;
      }
    },
  },
  methods: {
    ...mapActions({
      importJournal: 'DoorJournal/importJournal',
      getJournal: 'DoorJournal/getJournal',
    }),
    async updateInfo () {
      await this.getJournalDoor()
        .then(() => {
          this.$flash_success('Таблица обновлена!');
        });
    },
    keyCode (code) {
      if (!this.doorphone.device || this.doorphone.device.model !== 'Sokol-Plus') {
        return code || '';
      }
      const value = String(code || '').toUpperCase().replace(/[^0-9A-F]/g, '');
      return value.replace(/^0+/, '') || value;
    },
    metDateTime (date, time) {
      const dateTime = date + ' ' + time;
      return this.ruDateFormat(dateTime);
    },
    async getJournalDoor () {
      await this.importJournal(this.$route.params.id)
        .finally(importJournal => {
          if (this.roleName === 'master') {
            this.getJournal({
              id: this.$route.params.id,
              pagination: 1,
              limit: 10,
            })
              .catch((err) => {
                console.error(err);
                this.$flash_warning('Не удалось получить журнал открытия двери');
              });
          } else {
            this.getJournal({
              id: this.$route.params.id,
            })
              .catch((err) => {
                console.error(err);
                this.$flash_warning('Не удалось получить журнал открытия двери');
              });
          }
        });
    },
    getJournalType (key) {
      if (this.doorphone.device.model === 'RV-3434') {
        return JOURNAL_TYPES_RUBETEK3434[key];
      } else {
        return JOURNAL_TYPES[key];
      }
    },
    getJournalStatus (key) {
      return JOURNAL_STATUS[key];
    },
  },
};
</script>
